const { default: BrowseReportRoute } = require("./BrowseReport/BrowseReportRoute");
const { default: DetailReportRoute } = require("./DetailReport/DetailReportRoute");

export default { BrowseReportRoute, DetailReportRoute}